module.exports = __webpack_public_path__ + "img/mainImageQualityExplain.dbf4a835.png";